<template>
    <div>
        <div class="row justify-content-center">
            <div class="col-lg-5 col-md-7">
                <div class="card bg-secondary shadow border-0">
                    <div class="card-header bg-transparent pb-5">
                        <div class="text-muted text-center mt-2 mb-3">
                            <h1>{{$t('header_1')}}</h1>
                            <h4>{{$t('header_2')}}</h4>
                            <h3 style="color:red">{{$t('header_3')}}</h3>
                        </div>
                    </div>
                    <div class="card-body px-lg-5 py-lg-5">
                        <div class="text-center text-muted mb-4">
                           {{$t('login')}}
                        </div>
                        <ValidationObserver v-slot="{ passes }">
                            <form @submit.prevent="passes(onSubmit)">
                                <base-input class="input-group-alternative mb-3"
                                            :name="$t('email')"
                                            :label="$t('email')"
                                            :placeholder="$t('email')"
                                            required
                                            rules="required|email"
                                            v-model="form.email">
                                </base-input>

                                <base-input class="input-group-alternative"
                                            :name="$t('password')"
                                            :label="$t('password')"
                                            :placeholder="$t('password')"
                                            required
                                            rules="required|min:6"
                                            type="password"
                                            addon-right-icon="display-eye fa fa-eye"
                                            v-model="form.password">
                                </base-input>

                                <!-- <base-checkbox class="custom-control-alternative">
                                    <span class="text-muted">Remember me</span>
                                </base-checkbox> -->
                                <div class="text-center">
                                    <base-button nativeType="submit" :disabled="CheckButton" type="primary" class="my-4">{{$t('login')}}</base-button>
                                </div>
                            </form>
                        </ValidationObserver>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-6">
                        <router-link :to="'/'+$i18n.locale+'/forget'" class="text-light"><small>{{$t('forget_password')}}</small></router-link>
                    </div>
                    <div class="col-6 text-right">
                        <router-link :to="'/'+$i18n.locale+'/register'" class="text-light"><small>{{$t('create_account')}}</small></router-link>
                    </div>
                </div>
            </div>
            <modal :show.sync="modal"
                :gradient="modal_setting.gradient"
                modal-classes="modal-danger modal-dialog-centered">
                <div class="py-3 text-center">
                    <i class="ni ni-bell-55 ni-3x"></i>
                    <h4 class="heading mt-4"></h4>
                    <p>{{modal_setting.alert_text}}</p>
                </div>

                <template slot="footer">
                    <base-button type="link"
                                text-color="white"
                                class="ml-auto"
                                @click="modal = false">
                        {{$t('close')}}
                    </base-button>
                </template>
            </modal>
        </div>
    </div>
</template>
<script>
import { ValidationObserver } from "vee-validate"
import i18n from "@/i18n"
  export default {
    name: 'login',
    components: {
        ValidationObserver
    },
    data() {
      return {
        CheckButton: false,
        modal: false,
        modal_setting: {
            alert_text: '',
            gradient: ''
        },
        form: {
          email: '',
          password: ''
        }
      }
    },
    created () {
        this.checkCurrentLogin()
    },
    updated () {
        this.checkCurrentLogin()
    },
    methods: {
        checkCurrentLogin () {
            if (this.$store.state.token) {
                this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/dashboard')
            }
        },
        modalAlert (req) {
            if(req) {
                this.modal_setting.alert_text = req.data.message
            } else {
                this.modal_setting.alert_text = "ERROR"
            }
            this.modal_setting.gradient = "danger"
            this.modal = true
        },
        onSubmit () {
            this.CheckButton = true
            this.$http.post('auth/login', {
                "email": this.form.email,
                "password": this.form.password
            })
                .then(request => this.onSubmitSuccessful(request))
                .catch(() => this.onSubmitFailed())
        },
        onSubmitSuccessful (req) {
            if (req.data.code !== '0') {
                this.onSubmitFailed(req)
                return
            }
            this.$store.commit('addtoken', req.data.data.token)
            this.getProfile()
        },
        onSubmitFailed (req) {
            this.$store.commit('addtoken', '')
            this.modalAlert(req)
            this.CheckButton = false
        },
        getProfile () {
            this.$http.get('profile')
                .then(request => this.getProfileSuccessful(request))
                .catch(() => this.getProfileFailed())
        },
        getProfileSuccessful (req) {
            if (req.data.code !== '0') {
                this.getProfileFailed(req)
                return
            }
            this.$store.commit('addprofile', req.data.data)
            this.getGyms()
        },
        getProfileFailed (req) {
            this.$store.commit('addtoken', '')
            this.$store.commit('addprofile', '')
            this.modalAlert(req)
        },
        getGyms () {
            this.$http.get('gyms')
                .then(request => this.getGymsSuccessful(request))
                .catch(() => this.getGymsFailed())
        },
        getGymsSuccessful (req) {
            if (req.data.code === '0') {
                this.$store.commit('addgyms', req.data.data)
                this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/dashboard')
                return
            }
            if (req.data.code === '9010') {
                this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/addgym')
                return
            }
            if (req.data.code !== '0' || req.data.code !== '9010') {
                this.getGymsFailed(req)
                return
            }
        },
        getGymsFailed (req) {
            this.$store.commit('addtoken', '')
            this.$store.commit('addprofile', '')
            this.$store.commit('addgyms', '')
            this.modalAlert(req)
            this.CheckButton = false
        }
    }
  }
</script>
<style>
</style>
